/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlResponse {
    getFixupPrototypeFunction() { return ComplianceControlResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlResponse>): ComplianceControlResponse {
        let obj = Object.assign(new ComplianceControlResponse(), model);
        ComplianceControlResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlResponse>): ComplianceControlResponse {
        if (!model) return null;
        return ComplianceControlResponse.newInstance(<ComplianceControlResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlResponse) {
        if (!obj) return;

        models.ComplianceControlResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceControlResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * success
     */
    status: string;

    /**
     * compliance control execute triggered
     */
    message: string;

    /**
     * execute data.
     */
    assessment_jobs_by_account: any;

}
